<app-table
  [showPageSizeSelector]="false"
  [showPagination]="false"
  [data]="requests"
  [columns]="requestColumns"
></app-table>